/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
/* Client-only: the top-level code below runs immediately on require() and
 * touches document/window directly (self-mounting, same as ua.scroll.totop.js).
 * supportServer: false tells buildRegistry.js to swap in
 * ua.element.serverNotSupported.js's stub for registry.server.js (and the
 * base registry.js) instead of requiring this file in a Node context, where
 * window/document are, at best, an incomplete jsdom shim. */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "ua.scroll.progress",
    title: "UA Scroll Progress",
    description: "Adds a hairline bar to the top of the page that fills as the reader scrolls down the document. Only shows once the page has scrolled past a minimum threshold, same as UA Scroll to Top.",
    fields: false,
    editable: false,
    supportServer: false
});

var ScrollToBoundry = 1000;

/* Belt-and-suspenders alongside supportServer: false above: this only
 * mounts in a real browser (or a complete DOM environment). Some server
 * contexts define a partial/incomplete `window` (e.g. a jsdom wrapper
 * missing addEventListener) rather than leaving it undefined, so a plain
 * `typeof window !== "undefined"` check isn't enough — check for the actual
 * methods this file calls. */
var canMount = typeof window !== "undefined" && typeof window.addEventListener === "function"
    && typeof document !== "undefined" && typeof document.createElement === "function"
    && document.body;

if (canMount) {
    var uat_bar_progress = document.createElement("div");
    uat_bar_progress.style.position = "fixed";
    uat_bar_progress.style.left = "0";
    uat_bar_progress.style.top = "0";
    uat_bar_progress.style.width = "100%";
    uat_bar_progress.style.height = "3px";
    uat_bar_progress.style.zIndex = "100000";
    uat_bar_progress.style.background = "rgba(0,0,0,.08)";
    uat_bar_progress.style.opacity = "0";
    uat_bar_progress.style.display = "none";
    uat_bar_progress.style.pointerEvents = "none";
    uat_bar_progress.style.transition = "opacity .2s ease";

    var uat_bar_progress_fill = document.createElement("span");
    uat_bar_progress_fill.style.display = "block";
    uat_bar_progress_fill.style.height = "100%";
    uat_bar_progress_fill.style.width = "100%";
    uat_bar_progress_fill.style.transformOrigin = "left center";
    uat_bar_progress_fill.style.transform = "scaleX(0)";
    uat_bar_progress_fill.style.background = "var(--ua-progress-color, #2f6fed)";
    uat_bar_progress.appendChild(uat_bar_progress_fill);

    document.body.appendChild(uat_bar_progress);

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduceMotion) {
        uat_bar_progress_fill.style.transition = "transform .1s linear";
    }

    var scrollPct = function () {
        var doc = document.documentElement;
        var total = doc.scrollHeight - (window.innerHeight || doc.clientHeight);
        if (total <= 0) { return 0; }
        var p = (document.body.scrollTop || doc.scrollTop) / total;
        return p < 0 ? 0 : (p > 1 ? 1 : p);
    };

    var progressFunction = function () {
        uat_bar_progress_fill.style.transform = "scaleX(" + scrollPct().toFixed(4) + ")";

        // same threshold gate as UA Scroll to Top — only appear once the reader
        // has actually scrolled somewhere, not on short pages that barely scroll.
        if (document.body.scrollTop > ScrollToBoundry || document.documentElement.scrollTop > ScrollToBoundry) {
            uat_bar_progress.style.display = "block";
            if (uat_bar_progress.style.opacity == "0") {
                uat_bar_progress.style.opacity = "1";
            }
        } else {
            if (uat_bar_progress.style.opacity == "1") {
                uat_bar_progress.style.opacity = "0";
            }
        }
    };

    window.addEventListener("scroll", progressFunction, { passive: true });
    window.addEventListener("resize", progressFunction, { passive: true });
    progressFunction();
}

exports.render = async function (options) {
    throw new Error("The UA Scroll Progress element does not get rendered, it automatically adds itself to all pages.");
}
